import { TPagination } from "@custom-types/sorting";

export type TFinancialInstitutionsPaginated = TPagination & {
  data: Array<FinancialInstituteModel>;
};

export interface FinancialInstituteModel {
  bic: string;
  countryId: string;
  countryName: string;
  deleted: boolean;
  favourite: boolean;
  id: string;
  name: string;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class FinancialInstitute implements FinancialInstituteModel {
  bic = "";
  countryId = "";
  countryName = "";
  deleted = false;
  favourite = false;
  id = "";
  name = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: FinancialInstituteModel) {
    if (!dto) {
      return;
    }
    Object.assign(this, dto);
  }
}
